import React, { ChangeEvent, ComponentProps, useRef } from 'react';
import { Button, ButtonProps } from '@inpart-io/react-components';

export interface UploadButtonProps extends Omit<ComponentProps<typeof Button>, 'variant' | 'onClick'> {
  variant?: ButtonProps['variant'];
  handleFile: (file: File) => void;
  accept?: string[];
}

export const UploadButton = ({
  handleFile,
  variant = 'primary',
  children = <>Upload a file</>,
  accept = [],
  ...props
}: UploadButtonProps) => {
  const hiddenFileInput = useRef(null as HTMLInputElement | null);

  const handleClick = () => {
    hiddenFileInput.current?.click();
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    [...(event.target.files || [])].forEach(handleFile);
    event.target.value = '';
  };

  return (
    <>
      <Button type="button" variant={variant} onClick={handleClick} {...props}>
        {children}
      </Button>
      <input className="hidden" type="file" ref={hiddenFileInput} onChange={handleChange} accept={accept.join(',')} />
    </>
  );
};
